module.exports = __webpack_public_path__ + "img/icon-time.cd342d42.svg";